/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetMetricsQueryResponse, FilesControllerGetMetricsPathParams, FilesControllerGetMetrics400, FilesControllerGetMetrics401, FilesControllerGetMetrics403, FilesControllerGetMetrics404 } from "../../models/filesController/FilesControllerGetMetrics";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetMetrics } from "../../clients/filesService/filesControllerGetMetrics";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetMetricsQueryKey = (id: FilesControllerGetMetricsPathParams["id"]) => [{
  url: '/api/v1/files/:id/metrics',
  params: {
    id: id
  }
}] as const;
export type FilesControllerGetMetricsQueryKey = ReturnType<typeof filesControllerGetMetricsQueryKey>;
export function filesControllerGetMetricsQueryOptions(id: FilesControllerGetMetricsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetMetricsQueryKey(id);
  return queryOptions<FilesControllerGetMetricsQueryResponse, ResponseErrorConfig<FilesControllerGetMetrics400 | FilesControllerGetMetrics401 | FilesControllerGetMetrics403 | FilesControllerGetMetrics404>, FilesControllerGetMetricsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetMetrics(id, config);
    }
  });
}

/**
 * @description Returns counts of reviews and playbooks applied to a file.
 * @summary Get metrics for a file
 * {@link /api/v1/files/:id/metrics}
 */
export function useFilesControllerGetMetrics<TData = FilesControllerGetMetricsQueryResponse, TQueryData = FilesControllerGetMetricsQueryResponse, TQueryKey extends QueryKey = FilesControllerGetMetricsQueryKey>(id: FilesControllerGetMetricsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetMetricsQueryResponse, ResponseErrorConfig<FilesControllerGetMetrics400 | FilesControllerGetMetrics401 | FilesControllerGetMetrics403 | FilesControllerGetMetrics404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetMetricsQueryKey(id);
  const query = useQuery({
    ...filesControllerGetMetricsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerGetMetrics400 | FilesControllerGetMetrics401 | FilesControllerGetMetrics403 | FilesControllerGetMetrics404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}